import React from 'react';
import './MobileMenu.scss';
import Button from '../Common/CTA/Button';
import Logo from '../Common/Logo/Logo';
import { navItems } from '../../navItems';

function MobileMenu({ positionMobileMenu, mobileMenuRef, circleRef, topBarRef, bottomBarRef }) {
  return (
    <nav className="mobileMenu" ref={mobileMenuRef}>
      <div className="mobileMenu__contents">
        <button
          className="mobileMenu__contents__menu"
          aria-controls="menu"
          onClick={positionMobileMenu}
        >
          <div className="mobileMenu__contents__menu-container">
            <svg
              viewBox="0 0 42 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mobileMenu__contents__menu__circle"
              ref={circleRef}
            >
              <circle cx="21" cy="21" r="20.5" stroke="#4C4C4C" />
            </svg>
            <div className="mobileMenu__contents__menu__bars">
              <div
                className="navBar__contents__menu__bar navBar__contents__menu__bar-top mobileMenu__contents__menu__bar"
                ref={topBarRef}
              />
              <div
                className="navBar__contents__menu__bar navBar__contents__menu__bar-bttm mobileMenu__contents__menu__bar"
                ref={bottomBarRef}
              />
            </div>
          </div>
        </button>
        <a
          className="mobileMenu__contents__links mobileMenu__contents__links--story"
          href="#intro"
          onClick={positionMobileMenu}
        >
          STORY
        </a>
        <h6 className="mobileMenu__contents--suits">SUITS</h6>
        {navItems.map((item, i) => {
          return (
            <a
              key={i}
              className="mobileMenu__contents__links mobileMenu__contents__links--suits"
              href={`#${item.href}`}
              onClick={positionMobileMenu}
            >
              {item.copy}
            </a>
          );
        })}
        <a
          className="mobileMenu__contents__logo"
          href="https://sponsorcontent.cnn.com/interactive/morganstanley/creating-space/"
          target="_blanc"
        >
          <Logo location="menu" />
        </a>
        <div className="mobileMenu__contents__cta">
          <Button origin="intro" />
        </div>
      </div>
    </nav>
  );
}

export default MobileMenu;
